module.exports = __webpack_public_path__ + "img/0b3b7dc.jpg";